// extracted by mini-css-extract-plugin
module.exports = {"loader":"_2UXG_I","load7":"_3zFAeo"};